import { Component, Input, OnInit } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { ISelectOption } from "src/app/models/selectOptions";
import { PlaybookTemplatesService } from "src/app/services/templates/playbook/playbook-templates.service";

@Component({
    selector: "app-supported-resource-types-tooltip",
    templateUrl: "./supported-resource-types-tooltip.component.html",
    styleUrl: "./supported-resource-types-tooltip.component.scss",
})
export class SupportedResourceTypesTooltipComponent implements OnInit {
    @Input() public resourceTypeOptions$: BehaviorSubject<ISelectOption[]>;

    constructor(private _playbookTemplatesService: PlaybookTemplatesService) {}

    ngOnInit() {
        this.resourceTypeOptions$ = this._playbookTemplatesService.getResourceTypeOptions$();
    }
}
